import styles from '../../styles/admin/StudyContent.module.scss'
import Greeting from '../common/Greeting'

interface QuizContainerProps {
  children: React.ReactNode
}

const QuizContainer = ({ children }: QuizContainerProps) => {
  return <div className={styles.quizContainer}>{children}</div>
}

export default QuizContainer
